import { ReactNode, useContext } from "react";
import { Col, ColProps, Row, Typography } from "antd";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { colCardsConfig } from "../CityForm/GridStyle";

const { Text } = Typography;

interface IProps {
    title: string;
    icon?: ReactNode;
    subtitle?: string;
    extra?: ReactNode;
    children: ReactNode;
    colProps?: ColProps;
    span?: number;
}

export default function FieldsCard({ title, icon, subtitle, extra, children, colProps, span }: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const effectiveColProps: ColProps = colProps || (span ? { xs: 24, md: span } : colCardsConfig);

    return (
        <Col
            {...effectiveColProps}
            style={{
                padding: "8px",
            }}
        >
            <div
                style={{
                    background: isDark ? "#1a1a1a" : "#ffffff",
                    border: `1px solid ${isDark ? "#2a2a2a" : "#e2e8f0"}`,
                    boxShadow: isDark ? "0 1px 3px rgba(0,0,0,0.3)" : "0 1px 3px rgba(0,0,0,0.04)",
                    padding: "16px 18px",
                    borderRadius: 10,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 14,
                        paddingBottom: 10,
                        borderBottom: `1px solid ${isDark ? "#2a2a2a" : "#eaedf1"}`,
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {icon}
                        <div>
                            <Text strong style={{ fontSize: 13.5, color: isDark ? "#f0f0f0" : "#1e293b", display: "block" }}>
                                {title}
                            </Text>
                            {subtitle && (
                                <Text type="secondary" style={{ fontSize: 11.5, display: "block", marginTop: 1 }}>
                                    {subtitle}
                                </Text>
                            )}
                        </div>
                    </div>
                    {extra}
                </div>
                <Row gutter={[14, 14]} style={{ flex: 1, alignItems: "flex-start" }}>
                    {children}
                </Row>
            </div>
        </Col>
    );
}